import { useMemo } from "react";
import { ShippingRecordDispute } from "$types";
import { Services } from "$utils/typeConstants";
import useAuth from "./useAuth";
import { useList } from "$hooks/useList";

const useShippingRecordHistory = (shippingRecordId: string) => {
  const { token } = useAuth();

  // Use the new useList implementation
  const {
    data: histories,
    refetch: fetchHistories,
    isLoading: isFetching,
  } = useList<ShippingRecordDispute & { id: string | number }>(
    `shippingRecords/${shippingRecordId}/history`,
    {
      // Move service inside options
      service: Services.SHIPPING_API,
      // Add any additional options needed
      additionalParams: {},
      // Pass token if needed
      ...(token ? { jwt: token } : {}),
      // Only fetch if shippingRecordId is provided
      enabled: !!shippingRecordId,
    }
  );

  // If we still need custom sorting logic (e.g., the API doesn't support sorting by createdAt)
  const sortedHistories = useMemo(
    () =>
      [...histories].sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      ),
    [histories]
  );

  return {
    histories: sortedHistories,
    fetchHistories,
    isFetching,
  };
};

export default useShippingRecordHistory;
